import _ from "lodash";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearBasket } from "../../../redux/reducers/basket";
import { getRestaurant } from "../../../utils/commons";

const restaurant = getRestaurant();

const Content = () => {
	const basketState = useSelector((state) => state.basket);
	const dispatch = useDispatch();
	const [basket] = useState(_.cloneDeep(basketState));

	useEffect(() => {
		if (!basketState.order || !basketState.order.orderId) {
			window.location.replace("/");
		}
		dispatch(clearBasket());
	}, []);

	console.log("basket", basket);
	return (
		!!basket.order &&
		!!basket.order.orderId && (
			<section className="section">
				<div className="container">
					<div className="row align-items-center">
						<div className="offset-lg-3 col-lg-6 text-center">
							<p>
								<i className="flaticon-shopping-bag large_icon" />
							</p>
							<h5>Commande #{basket.order.displayId}</h5>
							<br />
							<h4>Merci {basket.info.firstName} pour votre commande,</h4>
							<p>
								Un e-mail de confirmation a été envoyé à l'adresse{" "}
								<strong>{basket.info.email}</strong>
								<br />
								Pensez à vérifier vos spams. <br /> <br />
								Votre commande sera prête à être servie à l'heure indiquée.{" "}
								<br />
								Des questions ? Contactez-nous au{" "}
								<strong>{restaurant.landline}</strong>
							</p>
						</div>
						<div className="offset-lg-3 col-lg-6 text-center">
							<p>Nous espérons vous revoir bientôt !</p>
						</div>
					</div>
				</div>
			</section>
		)
	);
};

export default Content;
